import { useQuery } from '@tanstack/react-query'

import { getSuspiciousTransactions } from '@src/api'
import { DefaultApiGetSuspiciousTransactionsRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchSuspiciousTransactions = (
  params: DefaultApiGetSuspiciousTransactionsRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.userAccountId,
    queryFn: () => getSuspiciousTransactions(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_SUSPICIOUS_TRANSACTIONS],
  })
}
